export const validateEmail = (email) => 
  /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email);

export const validatePassword = (password) => 
  /^(?=.*[a-zA-Z])(?=.*\d|.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$|^(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/.test(password);

export const validatePhoneNumber = (phone) => 
  /^01[016789]\d{7,8}$/.test(phone);